var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FreeToolsWrapper',[_c('AiDetectorView',{attrs:{"request-type":"free-tools"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }